import {
  BarChart2, Activity, TrendingUp, Search, Upload, FileText, Settings,
  Key, CreditCard, DollarSign, Clock, Shield, HelpCircle, Brain,
  Users, LayoutList, Table2, UserPlus, GitMerge
} from 'lucide-react';
import { NavigationSection } from '@/types/sidebar.types';

export const DEFAULT_NAVIGATION: NavigationSection[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: BarChart2,
    defaultExpanded: true,
    items: [
      { id: 'dashboard-overview', name: 'Overview', path: '/dashboard', icon: BarChart2 },
      { id: 'dashboard-activity', name: 'Recent Activity', path: '/dashboard/activity', icon: Activity },
      { id: 'dashboard-analytics', name: 'Analytics', path: '/dashboard/analytics', icon: TrendingUp },
    ],
  },
  {
    id: 'claims-discovery',
    title: 'Claims Discovery',
    icon: Search,
    items: [
      { id: 'claims-upload', name: 'Upload Database', path: '/claims/upload', icon: Upload },
      {
        id: 'claims-processing', name: 'Processing Jobs', path: '/claims/processing', icon: Activity,
        badge: { text: '2', variant: 'default' },
      },
      { id: 'claims-results', name: 'Results Management', path: '/claims/results', icon: FileText },
      { id: 'claims-analytics', name: 'Success Analytics', path: '/claims/analytics', icon: TrendingUp },
    ],
  },
  {
    id: 'reports',
    title: 'Reports',
    icon: FileText,
    items: [
      {
        id: 'reports-client-overlap',
        name: 'Client Overlap Report',
        path: '/reports/client-overlap',
        icon: FileText,
      },
    ],
  },
  {
    id: 'api-integration',
    title: 'API Integration',
    icon: Key,
    items: [
      { id: 'api-keys', name: 'API Keys', path: '/api/keys', icon: Key },
      { id: 'api-docs', name: 'Documentation', path: '/api/documentation', icon: FileText },
      { id: 'api-testing', name: 'Testing Console', path: '/api/testing', icon: Settings },
    ],
  },
  {
    id: 'account-billing',
    title: 'Account & Billing',
    icon: CreditCard,
    items: [
      {
        id: 'account-credits', name: 'Credit Balance', path: '/account/credits', icon: CreditCard,
        badge: { text: '2,847', variant: 'secondary' },
      },
      { id: 'account-purchase', name: 'Purchase Credits', path: '/account/purchase', icon: DollarSign },
      { id: 'account-usage', name: 'Usage History', path: '/account/usage', icon: Clock },
      { id: 'account-billing-records', name: 'Billing Records', path: '/account/billing', icon: FileText },
      { id: 'account-payment', name: 'Payment Methods', path: '/account/payment', icon: Shield },
    ],
  },

  {
    id: 'claimants',
    title: 'Claimants',
    icon: Users,
    defaultExpanded: false,
    items: [
      {
        id: 'claimants-pipeline',
        name: 'Pipeline View',
        path: '/claimants/pipeline',
        icon: LayoutList,
      },
      {
        id: 'claimants-spreadsheet',
        name: 'Spreadsheet View',
        path: '/claimants/spreadsheet',
        icon: Table2,
      },
      {
        id: 'claimants-add',
        name: 'Add Claimant',
        path: '/claimants/add',
        icon: UserPlus,
      },
      {
        id: 'claimants-overlaps',
        name: 'Overlap Review',
        path: '/claimants/overlaps',
        icon: GitMerge,
      },
    ],
  },
  {
    id: 'support',
    title: 'Support & Resources',
    icon: HelpCircle,
    items: [
      { id: 'support-guide', name: 'User Guide', path: '/support/guide', icon: FileText },
      { id: 'support-api', name: 'API Documentation', path: '/support/api', icon: Key },
      { id: 'support-tutorials', name: 'Video Tutorials', path: '/support/tutorials', icon: Brain },
      { id: 'support-contact', name: 'Contact Support', path: '/support/contact', icon: HelpCircle },
    ],
  },
];